module.exports = __webpack_public_path__ + "img/陈皮.09149976.jpg";